import React, { useEffect, useState } from 'react';

import ReassignCarButton from '../../components/CreditApplications/ReassignCarButton';
import getDealCars from '../../api/deals/getDealCars';
import formatNumber from '../../utils/formatNumber';

const styles = {
  card: { background: '#fff', border: '1px solid #E7E7ED', borderRadius: 8, padding: 24, marginTop: 20 },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, marginBottom: 20 },
  title: { fontWeight: 600, fontSize: 15 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px 24px' },
  label: { color: '#6A6A6A', fontSize: 12, lineHeight: '16px', marginBottom: 4 },
  value: { fontSize: 14, lineHeight: '20px', wordBreak: 'break-word' },
  note: { color: '#6A6A6A', fontSize: 13, marginBottom: 16 },
  warn: { background: '#FDEDED', border: '1px solid #EE7171', borderRadius: 8, padding: '10px 16px', marginBottom: 16 },
};

const Field = ({ label, value }) => (
  <div>
    <p style={styles.label}>{label}</p>
    <p style={styles.value}>{value || 'â'}</p>
  </div>
);

/**
 * ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð»Ð¸Ð´Ð° â Ð² Â«ÐÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¸Â», ÑÑÐ¾Ð±Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²Ð¸Ð´ÐµÐ» ÐµÐ³Ð¾ ÑÑÐ°Ð·Ñ. ÐÐ¾ÐºÐ°
 * ÑÐ´ÐµÐ»ÐºÐ¸ Ð½ÐµÑ, Ð¼Ð°ÑÐ¸Ð½Ð° Ð¸Ð·Ð²ÐµÑÑÐ½Ð° Ð¸Ð· Ð»Ð¸Ð´Ð° (ÐºÐ»Ð¸ÐµÐ½Ñ Ð¿Ð¾Ð»Ð¾Ð¶Ð¸Ð» ÐµÑ Ð² ÐºÐ¾ÑÐ·Ð¸Ð½Ñ); Ð¿Ð¾ÑÐ»Ðµ
 * ÐºÐ¾Ð½Ð²ÐµÑÑÐ°ÑÐ¸Ð¸ â Ð¼Ð°ÑÐ¸Ð½Ð° Ð°ÐºÑÐ¸Ð²Ð½Ð¾Ð¹ ÑÐ´ÐµÐ»ÐºÐ¸, ÐµÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð·Ð°Ð¼ÐµÐ½Ð¸ÑÑ.
 */
const LeadCarCard = ({ lead, onChanged }) => {
  const [dealCar, setDealCar] = useState(null);
  const activeDealId = lead?.deals?.[0]?.id;

  const loadDealCar = () => {
    if (!activeDealId) {
      setDealCar(null);
      return Promise.resolve();
    }
    return getDealCars({ id: activeDealId })
      .then((res) => setDealCar(res.data?.cars?.[0] || null))
      .catch(() => setDealCar(null));
  };

  useEffect(() => {
    loadDealCar();
  }, [activeDealId]);

  const leadCar = lead?.car;
  const car = dealCar
    ? {
        mark: dealCar.mark,
        model: dealCar.model,
        complectation: dealCar.complectation?.title || dealCar.complectation?.name,
        color: dealCar.color,
        issueYear: dealCar.issueYear,
        vin: dealCar.vin,
        city: dealCar.city?.title,
        engine_volume: dealCar.engine_volume,
        price: dealCar.price,
      }
    : leadCar;

  if (!car) return null;

  const carReleased = !!dealCar?.stockReturnedAt;

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <p style={styles.title}>{dealCar ? 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð² ÑÐ´ÐµÐ»ÐºÐµ' : 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ, Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼'}</p>
        {dealCar && (
          <ReassignCarButton
            orderId={dealCar.orderId}
            complectationId={dealCar.complectationId}
            color={dealCar.color}
            onDone={() => loadDealCar().then(() => onChanged && onChanged())}
          />
        )}
      </div>

      {carReleased && <div style={styles.warn}>Ð­ÑÐ° Ð¼Ð°ÑÐ¸Ð½Ð° ÑÐ¶Ðµ Ð½Ðµ Ð·Ð°ÐºÑÐµÐ¿Ð»ÐµÐ½Ð° Ð·Ð° ÑÐ´ÐµÐ»ÐºÐ¾Ð¹. ÐÐ¾Ð´Ð±ÐµÑÐ¸ÑÐµ Ð´ÑÑÐ³ÑÑ.</div>}
      {/* ÐÐ°ÑÐ¸Ð½Ñ Ð¿Ð¾ÑÑÐ¸ Ð²ÑÐµÐ³Ð´Ð° Ð´ÐµÑÐ¶Ð¸Ñ ÑÐ°Ð¼ ÐºÐ»Ð¸ÐµÐ½Ñ â ÑÑÐ¾ Ð½Ð¾ÑÐ¼Ð°Ð»ÑÐ½Ð¾, Ð° Ð½Ðµ Ð¿Ð¾Ð²Ð¾Ð´ Ð¿ÑÐ³Ð°ÑÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°. */}
      {!dealCar && leadCar?.reservedByClient && <p style={styles.note}>ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð½Ð°ÑÐ¾Ð´Ð¸ÑÑÑ Ð² ÐºÐ¾ÑÐ·Ð¸Ð½Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°.</p>}

      <div style={{ ...styles.grid, opacity: carReleased ? 0.5 : 1 }}>
        <Field label="ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ" value={[car.mark, car.model].filter(Boolean).join(' ')} />
        <Field label="ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ" value={car.complectation} />
        <Field label="Ð¦Ð²ÐµÑ" value={car.color} />
        <Field label="ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°" value={car.issueYear} />
        <Field label="VIN" value={car.vin} />
        <Field label="ÐÐ¾ÑÐ¾Ð´" value={car.city} />
        <Field label="ÐÐ²Ð¸Ð³Ð°ÑÐµÐ»Ñ" value={car.engine_volume ? `${car.engine_volume} ÑÐ¼Â³` : null} />
        <Field label="Ð¦ÐµÐ½Ð°" value={car.price ? `${formatNumber(car.price)} â¸` : null} />
      </div>
    </div>
  );
};

export default LeadCarCard;
